module.exports = {
	"name": "graylog-web-interface",
	"version": "2.2.0-SNAPSHOT",
	"description": "Graylog Web Interface",
	"author": "torch",
	"license": "GPL-3.0",
	"repository": {
		"type": "git",
		"url": "git://github.com/graylog2/graylog2-web-interface.git"
	},
	"readme": "../README.md",
	"scripts": {
		"start": "webpack --config webpack.vendor.js && webpack-dev-server --config webpack.combined.config.js",
		"start-nohmr": "webpack --config webpack.vendor.js && webpack-dev-server --watch --config webpack.combined.config.js",
		"build": "webpack -p --config webpack.vendor.js && webpack",
		"test": "webpack --config webpack.vendor.js && karma start karma.ci.conf.js",
		"prepare-dev": "./tools/prepare-dev"
	},
	"dependencies": {
		"bluebird": "^3.4.0",
		"c3": "^0.4.11-rc4",
		"classnames": "^2.2.0",
		"clipboard": "^1.5.5",
		"crossfilter": "1.3.x",
		"d3": "<=3.5.0",
		"dc": "2.0.0-beta.19",
		"deep-equal": "^1.0.1",
		"graylog-web-plugin": "file:packages/graylog-web-plugin",
		"history": "^1.17.0",
		"immutable": "^3.7.5",
		"javascript-natural-sort": "^0.7.1",
		"jquery-ui": "1.12.x",
		"lodash": "^4.17.4",
		"markdown": "^0.5.0",
		"md5": "^2.0.0",
		"moment-duration-format": "1.3.0",
		"numeral": "^1.5.3",
		"qs": "5.1.x",
		"react-day-picker": "^2.3.3",
		"react-dnd": "^2.0.2",
		"react-dnd-html5-backend": "^2.0.0",
		"react-overlays": "^0.6.5",
		"react-select": "^0.8.2",
		"rickshaw": "^1.5.1",
		"sockjs-client": "1.1.x",
		"string": "^3.3.1",
		"superagent": "^2.2.0",
		"superagent-bluebird-promise": "^4.1.0",
		"toastr": "^2.1.2",
		"typeahead.js": "^0.11.1",
		"ua-parser-js": "^0.7.12",
		"urijs": "^1.17.0"
	},
	"devDependencies": {
		"babel-core": "^6.0.0",
		"babel-loader": "^6.0.0",
		"babel-plugin-add-module-exports": "^0.2.1",
		"babel-polyfill": "^6.0.0",
		"babel-preset-es2015": "^6.0.0",
		"babel-preset-react": "^6.0.0",
		"babel-preset-stage-0": "^6.0.0",
		"clean-webpack-plugin": "^0.1.3",
		"css-loader": "^0.25.0",
		"enzyme": "^2.0.0",
		"eslint": "^2.2.0",
		"eslint-config-graylog": "file:packages/eslint-config-graylog",
		"eslint-loader": "^1.0.0",
		"estraverse-fb": "^1.3.1",
		"extract-text-webpack-plugin": "^1.0.1",
		"file-loader": "^0.9.0",
		"glob": "^7.0.0",
		"jasmine-core": "*",
		"json-loader": "^0.5.3",
		"karma": "^1.1.2",
		"karma-chrome-launcher": "*",
		"karma-html2js-preprocessor": "*",
		"karma-jasmine": "*",
		"karma-phantomjs-launcher": "*",
		"karma-webpack": "*",
		"less": "^2.5.3",
		"less-loader": "^2.2.1",
		"mocha": "^2.3.4",
		"phantomjs-prebuilt": ">=1.9",
		"react-hot-loader": "^3.0.0-beta.3",
		"react-proxy-loader": "^0.3.4",
		"script-loader": "^0.7.0",
		"style-loader": "^0.13.0",
		"ts-loader": "^0.8.2",
		"typescript": "^1.6.2",
		"url-loader": "^0.5.6",
		"webpack": "^1.12.6",
		"webpack-dev-server": "^1.12.0",
		"webpack-merge": "^0.x.x"
	}
};


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/package.json
// module id = 594
// module chunks = 0